// Промптът „Незавършена инвентаризация", когато листът е отворен без избор от
// началния екран (директен адрес, таблото), а има моя чернова — на сървъра или
// в този браузър (`useDraftResume`). Общият `DraftResumePrompt` с прегледа на
// приготвените рецепти и преброеното; Esc го затваря без избор (черновата
// остава).
import { useTranslation } from "react-i18next";
import type { Product } from "../../../../api/inventory";
import { DraftResumePrompt } from "../../components/drafts/DraftResumePrompt";
import { DRAFT_TEXTS } from "../../components/drafts/draftTexts";
import { stocktakeDraftPreview, type StocktakeDraft } from "./stocktakeDraft";

type Props = {
  draft: StocktakeDraft | null;
  productById: Map<number, Product>;
  decimalsOf: (productId: number) => number;
  onContinue: () => void;
  onDiscard: () => void;
  // Esc / клик по фона — затваря, без да решава
  onDismiss: () => void;
};

export const StocktakeDraftPrompt = ({
  draft,
  productById,
  decimalsOf,
  onContinue,
  onDiscard,
  onDismiss,
}: Props) => {
  const { t } = useTranslation();
  const { items, total } = stocktakeDraftPreview(t, draft, productById, decimalsOf);
  return (
    <DraftResumePrompt
      open={draft != null}
      texts={DRAFT_TEXTS.stocktake}
      savedAt={draft?.savedAt ?? null}
      savedBy={draft?.savedBy ?? null}
      items={items}
      total={total}
      onContinue={onContinue}
      onDiscard={onDiscard}
      onDismiss={onDismiss}
    />
  );
};

export default StocktakeDraftPrompt;
